import CustomerAnalysisRepository from "@/core/customers/repositories/CustomerAnalysisRepository";
import {
  CustomerAnalysisResponse,
  KYCAnalysis,
  RiskAnalysis,
  ScreeningReport,
} from "@/core/customers/entities/CustomerAnalysis";

export default class CustomerAnalysisRepositoryMock
  implements CustomerAnalysisRepository
{
  async getCustomerAnalysis(): Promise<CustomerAnalysisResponse> {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));

    // Mock KYC Analysis data
    const kycAnalysis: KYCAnalysis = {
      overallStatus: "COMPLETE",
      lastReview: "04/09/2025 13:03:22",
      nextReview: "2026-09-05 (R3)",
      documents: [
        {
          code: "CNI",
          title: "Pièce d'identité",
          status: "VALID",
          expiration: "2026-09-05",
        },
        {
          code: "ADDR_PROOF",
          title: "Justif. domicile",
          status: "VALID",
          expiration: "—",
        },
      ],
      riskFactors: {
        pep: false,
        clientType: "PP",
        residence: "resident",
        activityRisk: "medium",
      },
      rule: "Règle défaut: PM/non-résident/activité medium ⇒ Standard + R3",
    };

    // Mock Risk Analysis data
    const riskAnalysis: RiskAnalysis = {
      profile: "STANDARD",
      score: 42,
      triggers: ["GEO_MEDIUM", "SECTOR_STANDARD"],
      nextReKyc: "2026-09-08 (R3)",
      eddStatus: "Aucun",
    };

    // Mock Screening Reports data
    const screeningReports: ScreeningReport[] = [
      {
        title: "ZFSCaseMatchDetailsReport_e_tr_wci_2512764",
        client: "Aïcha DIENG",
        dataset: "PEP (Personne Politiquement Exposée)",
        status: "Active",
        source: "LSEG World-Check",
        date: "05/09/2025",
        details: {
          result: "—",
          category: "Political Individual",
          subcategory: "PEP – National Government",
          pepStatus: "Active",
          rating: "—",
          birthDate: "1976-02-29",
          nationality: "Côte d'Ivoire",
          locations: "Abidjan (Lagunes), Daloa (Sassandra-Marahoué)",
          source: "LSEG World-Check · 06/09/2025 14:37:34",
          details: `Fonctions principales:
- Ministre de la Promotion de la Jeunesse et de l'Emploi des Jeunes, Porte-parole adjoint du
Gouvernement (2018–2023, reconduit 2023–)
- Secrétaire d'État à la Formation Technique et Professionnelle (2017–2018)
- Député à l'Assemblée Nationale (2016–2018)
- Conseiller Jeunesse auprès du Président (2011–2016)
- Porte-parole et responsable communication au sein du RHDP et du RDR
Organisations liées:
- OISSU, ONS, RHDP, RDR
Alias: TOURÉ, Mamadou`,
        },
      },
      {
        title: "CaseDossierReport_RaymondA",
        client: "Aïcha DIENG",
        dataset: "KYC/Screening",
        status: "Not Rated",
        source: "Internal Dossier",
        date: "05/09/2025",
      },
    ];

    return {
      code: "200",
      message: "Customer analysis data retrieved successfully",
      data: {
        kycAnalysis,
        riskAnalysis,
        screeningReports,
      },
    };
  }
}
